module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "factoring"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "factoring_tit w"
  }, [(this.$route.query.yanse == 1) ? _c('h2', {
    staticClass: "factoring_h"
  }, [_vm._v("供应链融资")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2) ? _c('h2', {
    staticClass: "factoring_h"
  }, [_vm._v(_vm._s(this.$route.query.productName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "limit-baoli"
  }, [_c('ul', [(this.$route.query.yanse == 1) ? _c('li', {
    staticClass: "limit"
  }, [_c('p', [_vm._v("关于额度")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("供应链融资是以供应商共享买方的银行授信额度为前提的融资方式。额度的具体使用会根据合作银行的不同分为先占先用或买方主动分配等。")])]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 1) ? _c('li', {
    staticClass: "limit"
  }, [_c('p', [_vm._v("关于账户")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("供应链融资需要供应商在买方授信所在银行具有一般结算账户，在此账户基础上设立专用于供应链融资的回款专户。")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("回款专户不可操作，属于买方应付到期时支付货款的指定路径。")])]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2 && this.$route.query.productName == '正向保理') ? _c('li', {
    staticClass: "limit"
  }, [_c('p', [_vm._v("客户准入")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("客户在本系统提交相关信息完成实名认证后，签订《商业保理合同》开通融资权限及可用额度")])]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2 && this.$route.query.productName == '正向保理') ? _c('li', {
    staticClass: "limit"
  }, [_c('p', [_vm._v("业务申请")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("客户在本系统录入与应收账款相关的资料（发票及贸易合同等），我司将对贸易真实性进行审核，并根据融资产品及客户信用状况进行具体业务的审批")])]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2 && this.$route.query.productName != '正向保理') ? _c('li', {
    staticClass: "limit"
  }, [_c('p', [_vm._v("额度申请")]), _vm._v(" "), _c('span', [_vm._v("客户有意向平台发起融资申请时，需要先进行额度申请，平台对客户进行尽调，授信一定的额度，客户可在额度范围内进行融资申请。")])]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2 && this.$route.query.productName != '正向保理') ? _c('li', {
    staticClass: "limit"
  }, [_c('p', [_vm._v("融资申请")]), _vm._v(" "), _c('span', [_vm._v("供应商可录入贸易合同及应收账款信息相本平台发起融资申请，平台对客户的融资申请进行审核，根据客户申请的融资类型及信用状况确定融资")])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "factoring_btn",
    on: {
      "click": function($event) {
        return _vm.beginApplyLoan()
      }
    }
  }, [_vm._v("立即申请")])])])]), _vm._v(" "), _c('div', {
    staticClass: "factoring_main w"
  }, [(this.$route.query.yanse == 1) ? _c('div', {
    staticClass: "factoring_nav tit_public"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2 && this.$route.query.productName == '正向保理') ? _c('div', {
    staticClass: "factoring_nav tit_public"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2 && this.$route.query.productName != '正向保理') ? _c('div', {
    staticClass: "factoring_nav tit_public"
  }, [_c('button', {
    staticClass: "bright",
    class: {
      cur: _vm.isBright
    },
    on: {
      "click": function($event) {
        return _vm.bright()
      }
    }
  }, [_vm._v("明保理")]), _vm._v(" "), _c('button', {
    staticClass: "dark",
    class: {
      cur: _vm.isDark
    },
    on: {
      "click": function($event) {
        return _vm.dark()
      }
    }
  }, [_vm._v("暗保理")])]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 1) ? _c('div', {
    staticClass: "presentation"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4)]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2 && this.$route.query.productName == '正向保理') ? _c('div', {
    staticClass: "presentation"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6)]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2 && this.$route.query.productName != '正向保理') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBright),
      expression: "isBright"
    }],
    staticClass: "presentation"
  }, [_c('p', {
    staticClass: "presentation_tit"
  }, [_vm._v("借款人借款，核心企业知晓给你应收账款的保理业务")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDark),
      expression: "isDark"
    }],
    staticClass: "presentation"
  }, [_c('p', {
    staticClass: "presentation_tit"
  }, [_vm._v("借款人借款，核心企业知晓给你应收账款的保理业务")]), _vm._v(" "), _vm._m(9)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_vm._m(10), _vm._v(" "), _c('ul', {
    staticClass: "flow_list"
  }, _vm._l((_vm.flowArr), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "flow_li"
    }, [_c('div', {
      staticClass: "flow_icon"
    }, [_c('img', {
      attrs: {
        "src": item.url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "flow_name colorF"
    }, [_vm._v(_vm._s(item.flowName))]), _vm._v(" "), _c('p', {
      staticClass: "flow_tit"
    }, [_vm._v(_vm._s(item.flowDetails))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "condition"
  }, [_vm._m(11), _vm._v(" "), _c('ul', {
    staticClass: "condition_list"
  }, _vm._l((_vm.conditionArr), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "condition_li"
    }, [_c('span', [_vm._v(_vm._s(item.compactName))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "text-indent": "2em"
      }
    }, [_vm._v(_vm._s(item.compactMain))])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "factoring_Img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/product.jpg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "flow_h tit_public colorF"
  }, [_c('span', {
    staticClass: "tit_span",
    staticStyle: {
      "margin-right": "2em"
    }
  }, [_vm._v("中国银行")]), _c('span', {
    staticClass: "tit_span"
  }, [_vm._v("顺德农商")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "flow_h tit_public colorF"
  }, [_c('span', {
    staticClass: "tit_span",
    staticStyle: {
      "margin-right": "2em"
    }
  }, [_vm._v("回购型")]), _c('span', {
    staticClass: "tit_span"
  }, [_vm._v("明保理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presentation_l f_public"
  }, [_c('div', {
    staticStyle: {
      "color": "#EB662B"
    }
  }, [_vm._v("无追索")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "width": "320px"
    }
  }, [_vm._v("买方的逾期付款风险由银行承担")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presentation_r f_public"
  }, [_c('div', {
    staticStyle: {
      "color": "#EB662B"
    }
  }, [_vm._v("100%")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "width": "320px"
    }
  }, [_vm._v("无需保证金，买方应付金额即为可融资金额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presentation_l f_public"
  }, [_c('div', {
    staticStyle: {
      "color": "#EB662B"
    }
  }, [_vm._v("回购型")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "width": "320px",
      "text-align": "left",
      "line-height": "30px"
    }
  }, [_vm._v("保理商和供应商约定，在供应商融资到期后，若买方不能如期足额支付货款的，供应商负责融资额回购义务")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presentation_r f_public"
  }, [_c('div', {
    staticStyle: {
      "color": "#EB662B"
    }
  }, [_vm._v("明保理")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "width": "320px",
      "text-align": "left",
      "line-height": "30px"
    }
  }, [_vm._v("供应商在转让应收账款后，出具《应收账款转让通知书》并寄送到买方，明确告知买方债权已转让，付款路径需变更至指定收款账户")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presentation_l f_public"
  }, [_c('div', {
    staticStyle: {
      "color": "#EB662B"
    }
  }, [_vm._v("回购型")]), _vm._v(" "), _c('p', [_vm._v("借款人借款，核心企业到期付款给平台, 若不付款则由借款人付款")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presentation_r f_public"
  }, [_c('div', {
    staticStyle: {
      "color": "#EB662B"
    }
  }, [_vm._v("买断型")]), _vm._v(" "), _c('p', [_vm._v("借款人借款，核心企业到期付款给平台, 若拒付风险由平台承担")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "f_public presentation_dark"
  }, [_c('div', {
    staticStyle: {
      "color": "#EB662B"
    }
  }, [_vm._v("还款方式")]), _vm._v(" "), _c('p', [_vm._v("借款人借款，核心企业到期付款给平台, 若拒付风险由平台承担")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "flow_h tit_public colorF"
  }, [_c('span', {
    staticClass: "tit_span"
  }, [_vm._v("申请流程")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "condition_h tit_public"
  }, [_c('span', {
    staticClass: "tit_span"
  }, [_vm._v("流程资料")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ecdadfb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/Factoring.vue
// module id = 1051
// module chunks = 1